
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stars/[id]",
      function () {
        return require("private-next-pages/stars/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stars/[id]"])
      });
    }
  